/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

// Misc imports
import { getCurrentQueryState } from '../../../store/utils/getCurrentQueryState';
import is from '../../is';
import { CONVERSATION_STATUSES, LIVECHAT_MODES } from '../../../constants/liveChat';

export const useConversationStatus = () => {
  const { orgId } = useParams();
  const [searchParams] = useSearchParams();
  const [hasJoined, setHasJoined] = useState(false);
  const [canRejoin, setCanRejoin] = useState(false);
  const [isInactive, setIsInactive] = useState(false);
  const { currentData: activeConversationInfo } = getCurrentQueryState('fetchActiveConversation', { orgId, conversationId: searchParams.get('conversation') });
  const { data: livechatSettings } = getCurrentQueryState('fetchLiveChatApplicationSettings', { orgId });
  const { currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!activeConversationInfo) {
      return;
    }
    const me = activeConversationInfo?.livechatParticipants?.find(agent => agent.platformUserId === currentUser.id);

    const joined = is.truthy(me);
    setHasJoined(joined);

    if (livechatSettings?.livechatMode === LIVECHAT_MODES.PUBLIC && activeConversationInfo.status !== CONVERSATION_STATUSES.FINISHED && joined && me?.status !== 'active') {
      setCanRejoin(true);
    } else {
      setCanRejoin(false);
    }

    if (me?.status === 'inactive' || me?.status === 'transferred' || activeConversationInfo.status === CONVERSATION_STATUSES.FINISHED) {
      setIsInactive(true);
    } else {
      setIsInactive(false);
    }
  }, [activeConversationInfo?.livechatParticipants, activeConversationInfo?.status, livechatSettings?.livechatMode]);

  return [hasJoined, isInactive, canRejoin];
};
